export const MESSAGE_EVENTS = {
  UPDATED: {
    TITLE: "updatedTitle",
    BODY: "updatedBody",
    PARAMS: "updatedParams",
    TEMPLATE: "updatedTemplate",
    IMAGE: "updatedImage",
    VIDEO: "updatedVideo",
    FILE: "updatedFile",
    LATITUDE: "updatedLatitude",
    LONGITUDE: "updatedLongitude",
    EMAIL: "updatedEmail",
    WEBHOOK: "updatedWebhook",
    FORM_FIELDS: "updatedFormFields",
    MULTIMEDIA: "updateMultimedia",
    BUTTON_PARAMS: "updatedButtonParams"
  }
};

export const PARAMS_DATA_TYPES = {
  STRING: "string",
  DATE: "date",
  NUMBER: "number",
  TIME: "time",
  MULTIMEDIA: "multimedia"
};

export const MESSAGE_PARAMETERS_NOT_FOUND =
  "No se encontró configuración de parámetros para la plantilla seleccionada.";

export const UPDATE_PARAMS_LIST_EVENT = "updateParamsList";

export const MESSAGE_TYPE = {
  FILE: "FILE",
  LOCATION: "LOCATION",
  VIDEO: "VIDEO",
  IMAGE: "IMAGE"
};
